import { render, staticRenderFns } from "./BranchManualFreightTab.vue?vue&type=template&id=f3b50054&scoped=true"
import script from "./BranchManualFreightTab.vue?vue&type=script&lang=js"
export * from "./BranchManualFreightTab.vue?vue&type=script&lang=js"
import style0 from "./BranchManualFreightTab.vue?vue&type=style&index=0&id=f3b50054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b50054",
  null
  
)

export default component.exports